import React from 'react'

import './pagination.scss'

export default function Pagination({ setCurrentPage, currentPage, search, allEmployers, contentPerPage }) {
  return (
    <div className='pagination'>
      <button onClick={() => setCurrentPage(1)}>Start</button>
      <button onClick={() => setCurrentPage(currentPage - 1)} className={currentPage - 1 === 0 ? 'disable' : null}>
        {currentPage - 1}
      </button>
      <button className='active'>{currentPage}</button>
      <button
        onClick={() => setCurrentPage(currentPage + 1)}
        className={
          currentPage + 1 >
          Math.ceil(allEmployers.filter(element => element.name.toLowerCase().includes(search.toLowerCase())).length / contentPerPage)
            ? 'disable'
            : null
        }>
        {currentPage + 1}
      </button>
      <span
        className={
          currentPage + 10 >
          Math.ceil(allEmployers.filter(element => element.name.toLowerCase().includes(search.toLowerCase())).length / contentPerPage)
            ? 'disable'
            : null
        }>
        ...
      </span>
      <button
        onClick={() => setCurrentPage(currentPage + 10)}
        className={
          currentPage + 10 >
          Math.ceil(allEmployers.filter(element => element.name.toLowerCase().includes(search.toLowerCase())).length / contentPerPage)
            ? 'disable'
            : null
        }>
        {currentPage + 10}
      </button>
      <button
        onClick={() =>
          setCurrentPage(Math.ceil(allEmployers.filter(element => element.name.toLowerCase().includes(search.toLowerCase())).length / contentPerPage))
        }>
        Last
      </button>
    </div>
  )
}
